import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'rebass'

import Service from './Service'

const Services = ({ services }) => (
  <Flex justifyContent="center" mx={-3} flexWrap="wrap">
    {services.map(({ service }) => {
      const {
        frontmatter: {
          id,
          title,
          image: {
            childImageSharp: { sizes: image },
          },
        },
        html,
      } = service
      return <Service key={id} image={image} title={title} description={html} />
    })}
  </Flex>
)

Services.propTypes = {
  services: PropTypes.array,
}

export default Services



// WEBPACK FOOTER //
// ./src/containers/Services/Services.js